import { Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import type { ConfirmDeletePreviewFields } from "../../shared/components/ConfirmDeletePreview";
import { formatInr } from "../../shared/utils/currency";
import { formatDate } from "../../shared/utils/date";
import type { BillEntryRow, FilterState, VoucherKind } from "./billEntryTypes";
import { voucherLabel } from "./billEntryTypes";

export const billEntryColumns: ColumnsType<BillEntryRow> = [
  { title: "Bill No", dataIndex: "billNo", width: 140, render: (v) => v || <span className="muted-cell">Auto</span> },
  { title: "Date", dataIndex: "billDate", width: 130, render: formatDate },
  { title: "Party", dataIndex: "partyName", width: 240, render: (v) => v || <span className="muted-cell">-</span> },
  { title: "Voucher", dataIndex: "voucherType", width: 160, render: (v) => <Tag>{voucherLabel(v)}</Tag> },
  { title: "Ledger", dataIndex: "ledgerName", width: 220, render: (v) => v || <span className="muted-cell">-</span> },
  { title: "Reference", dataIndex: "referenceNo", width: 150, render: (v) => v || <span className="muted-cell">-</span> },
  { title: "Amount", dataIndex: "grandTotal", align: "right", width: 150, render: (v, row) => formatInr(v ?? row.totalAmount ?? 0) },
  {
    key: "files",
    title: "Files",
    width: 100,
    render: (_, row) => {
      const count = Number(row.billAttachmentCount ?? 0) + Number(row.voucherAttachmentCount ?? 0);
      return count ? <Tag color="blue">{count}</Tag> : <span className="muted-cell">-</span>;
    }
  },
  { title: "Posted", dataIndex: "isPosted", width: 110, render: (v) => <Tag color={v ? "green" : "gold"}>{v ? "Posted" : "Draft"}</Tag> }
];

export function buildActiveFilters(filters: FilterState, fixedVoucherType?: VoucherKind) {
  const items: { key: keyof FilterState; label: string }[] = [];
  if (filters.search) items.push({ key: "search", label: `Search: ${filters.search}` });
  if (filters.billNo) items.push({ key: "billNo", label: `Bill No: ${filters.billNo}` });
  if (!fixedVoucherType && filters.voucherType) items.push({ key: "voucherType", label: `Voucher: ${voucherLabel(filters.voucherType)}` });
  if (filters.isPosted !== undefined) items.push({ key: "isPosted", label: filters.isPosted ? "Posted" : "Draft" });
  if (filters.dateRange) items.push({ key: "dateRange", label: `${filters.dateRange[0].format("DD-MMM-YYYY")} to ${filters.dateRange[1].format("DD-MMM-YYYY")}` });
  return items;
}

export function deletePreviewFields(row: BillEntryRow): ConfirmDeletePreviewFields {
  return [
    { label: "Bill No", value: row.billNo || "Auto" },
    { label: "Date", value: row.billDate, type: "date" },
    { label: "Party", value: row.partyName },
    { label: "Voucher", value: voucherLabel(row.voucherType), type: "tag" },
    { label: "Amount", value: row.grandTotal ?? row.totalAmount, type: "money" },
    { label: "Reference", value: row.referenceNo }
  ];
}
